import useModal from "@/hooks/useModal";
import Button from "@/components/Button";

export default function CancelSessionModal({
  onDismiss,
  onEraseAndLeave
}: {
  onDismiss: () => void;
  onEraseAndLeave: () => void;
}) {
  const { Modal, close } = useModal();

  const handleKeep = () => {
    close();
    onDismiss();
  };

  const handleEraseAndLeave = () => {
    close();
    onEraseAndLeave();
  };

  return (
    <Modal
      onClosed={onDismiss}
      actions={
        <>
          <div className="flex gap-2">
            <Button variant="text" onClick={handleKeep} testId="cancel-session-keep-button">
              Cancel
            </Button>
            <Button variant="filled" theme="error" onClick={handleEraseAndLeave} testId="erase-session-confirm-button">
              Discard Changes
            </Button>
          </div>
        </>
      }
      headline="Unsaved Session"
      className="md:w-[520px]"
    >
      <p className="text-body-large text-sys-brand-on-surface">
        Are you sure you want to leave? Your unsaved changes will be discarded.
      </p>
    </Modal>
  );
}
